export const dummySingleCrypto = [
  {
    id: "BTC",
    currency: "BTC",
    symbol: "BTC",
    name: "Bitcoin",
    logo_url:
      "https://s3.us-east-2.amazonaws.com/nomics-api/static/images/currencies/btc.svg",
    status: "active",
    price: "42204.58459802",
    price_date: "2021-08-01T00:00:00Z",
    price_timestamp: "2021-08-01T04:51:00Z",
    circulating_supply: "18772862",
    max_supply: "21000000",
    market_cap: "792300842426",
    market_cap_dominance: "0.4399",
    num_exchanges: "385",
    num_pairs: "61775",
    num_pairs_unmapped: "5184",
    first_candle: "2011-08-18T00:00:00Z",
    first_trade: "2011-08-18T00:00:00Z",
    first_order_book: "2017-01-06T00:00:00Z",
    rank: "1",
    rank_delta: "0",
    high: "63596.58160404",
    high_timestamp: "2021-04-13T00:00:00Z",
    "1d": {
      volume: "29384213820.55",
      price_change: "391.26717061",
      price_change_pct: "0.0094",
      volume_change: "-18671407738.07",
      volume_change_pct: "-0.3885",
      market_cap_change: "7387017916.45",
      market_cap_change_pct: "0.0094",
    },
  },
];
export const singlePortfolio = {
  data: [...Array(10).keys()].map((c, index) => {
    return {
      _id: index + 1,
      createdAt: index + 1,
      curramout: index + 1,
      initamount: index + 1,
      isExpert: index + 1,
      isPaid: index + 1,
      isPublic: index + 1,
      lockamount: index + 1,
      pid: index + 1,
      serno: index + 1,
      status: index + 1,
      updatedAt: index + 1,
    };
  }),
};
export const dummyOrders = [...Array(10).keys()].map((c, index) => ({
  _id: "61012a322ccc5aa4f455eb1d",
  pid: "60fbc801d18466001e17b193",
  portId: "60fbc801d18466001e17b197",
  symbol: "ETH",
  __v: 0,
  amount: 1,
  createdAt: "2021-07-28T09:58:10.543Z",
  price: 2583.55,
  updatedAt: "2021-08-01T14:45:26.578Z",
  fifoInvestedAmount: 2583.55,
  invAmount: 2583.55,
  qtyAvailableToSell: 1,
}));
export const dummyHistoryOrders = [...Array(10).keys()].map((c, index) => ({
  _id: "6107638095f088002cdb052b",
  portId: "60fbc801d18466001e17b197",
  pid: "60fbc801d18466001e17b193",
  amount: 0.9992744567951547,
  symbol: "USDT",
  price: 1.00072607,
  type: "buy",
  status: 3,
  created_at: "2021-08-02T03:16:16.127Z",
  total: 1,
  createdAt: "2021-08-02T03:16:16.128Z",
  updatedAt: "2021-08-02T03:16:16.128Z",
  __v: 0,
}));

export const dummyOpenOrders = [...Array(10).keys()].map((c, index) => ({
  _id: "6106cf4e3db7dc0029bce1e2",
  portId: "60fbc801d18466001e17b197",
  pid: "60fbc801d18466001e17b193",
  amount: 10.294055845152947,
  symbol: "ETH",
  price: 247.47,
  type: "buy",
  status: 1,
  created_at: "2021-08-01T16:43:58.532Z",
  total: 2547.47,
  createdAt: "2021-08-01T16:43:58.533Z",
  updatedAt: "2021-08-01T16:43:58.533Z",
  __v: 0,
}));
export const dummyCoins = [...Array(10).keys()].map((c, index) => {
  return {
    buyPrice: 1,
    currPrice: 1,
    avgPrice: null,
    pl: 1,
    perChange: -1,
    _id: "60d6c4343a76ff38601bc165",
    rmid: "60cf9f20433909436cce7c80",
    rid: "60cf9f20433909436cce7c7e",
    cname: "ACA",
    quantity: 21739130434.782608,
    cstAmount: 10000,
    createdAt: "2021-06-26T06:07:48.026Z",
    updatedAt: "2021-07-02T18:44:55.826Z",
    __v: 0,
  };
});
export const dummyNewsData = [...Array(10).keys()].map((c, index) => {
  return {
    text: "Source: Instagram, Binance The crypto exchange giant Binance has run into yet more regulatory trouble in Asia while it's making new preventive moves in Europe. The platform issued a notice on its Binance.com website explaining that it “plans to wind down its futures and derivatives products offerings across the European region. It claimed that it would begin with its operations in Germany,",
    image_url: "https://crypto.snapi.dev/images/v1/z/z/3e3214e648-46512.png",
    date: "Fri, 30 Jul 2021 07:31:00 -0400",
    source_name: "Cryptonews",
    news_url:
      "https://cryptonews.com/news/binance-winds-down-derivatives-in-europe-while-malaysia-take-11261.htm",
  };
});
